export default "__VITE_ASSET__Ckgg2OUV__"